import React, {useState, useEffect,useCallback } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';

// Import the default styles
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'; // D&D styles

import AppLayout from '../../../../layout/components/AppLayout';
import taskServices from '../taskServices';
import TaskForm from '../components/TaskForm';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import { Link } from 'react-router-dom';
import { List } from '@mui/icons-material';

// Initialize the localizer with moment
const localizer = momentLocalizer(moment);

// Create the Drag and Drop Calendar component
const DragAndDropCalendar = withDragAndDrop(Calendar);


/*
const CustomEvent = ({ event,callBack, masters, getMasterLabel }) => {
    return(
       <TaskForm data={event.originalTask} onSuccess={callBack} masters={masters} getMasterLabel={getMasterLabel} />
    )

}
*/




const TaskCalendarPage = () => {

    const masterList = ['client','priority','project','task-status'];
    const [masters,getMasterLabel] = useSystemMasterList(masterList);
    const [selectedEvent,setSelectedEvent] = useState(null);
    
    const [loading,setLoadingStatus] = useState(false);
    const [taskList,setTaskList] = useState(null);
    const getByGroup = () => {
        setLoadingStatus(true);
        taskServices.getList().then(res=>{
            setTaskList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const eventPropGetter = ({originalTask}) => {
        let $className = "";
        let eod = moment(originalTask.endDate)
        let now = moment();
        let _diff = eod.diff(now,'hours')
        //console.log(_diff)
        _diff+=24;

        if(_diff < 0){ // Over Due
            $className = "bg-danger blink-infinite text-white p-0";
        }
        if(_diff >= 0 && _diff <= 24 ){ //Today
            $className = "bg-danger text-white p-0";
        }
        if(_diff > 24 ){ // tomorrow
            $className = "bg-warning text-dark p-0";
        }
        if(_diff > 48 ){ //later"
            $className = "bg-success text-white p-0";
        }
        return {className :$className};
    }

    const mapTasksToEvents = (tasks) => {
    return tasks
        .filter(task => task.startDate && task.endDate) // Only include tasks with valid dates
        .map(task => ({
            // Required fields for react-big-calendar
            id: task.id,
            title: task.title,
            // Convert string dates to JavaScript Date objects for the calendar
            start: new Date(task.endDate), 
            end: new Date(task.endDate), 
            
            // Optional: You can include your original data here for custom handlers
            originalTask: task,
        }));
    };

    

    // STATE FOR CALENDAR EVENTS (Tasks are now managed in local state)
    const [events, setEvents] = useState([]);
    useEffect(() => {
        if (taskList && taskList.length > 0 && taskList) {
            const mappedEvents = mapTasksToEvents(taskList);
            setEvents(mappedEvents);
        }
    }, [taskList]);

    // HANDLER FOR EVENT MOVE (Drag and Drop)
    const moveEvent = useCallback(
        ({ event, start, end }) => {
            // Update the state locally (even if you don't call the API)
            const nextEvents = events.map(existingEvent => {
                return existingEvent.id === event.id
                    ? { ...existingEvent, start, end }
                    : existingEvent;
            });
            setEvents(nextEvents);
            console.warn("Task moved locally! Call your update API here.");
        },
        [events]
    );

    // HANDLER FOR EVENT RESIZE
    const resizeEvent = useCallback(
        ({ event, start, end }) => {
            // Update the state locally
            const nextEvents = events.map(existingEvent => {
                return existingEvent.id === event.id
                    ? { ...existingEvent, start, end }
                    : existingEvent;
            });
            setEvents(nextEvents);
            console.warn("Task resized locally! Call your update API here.");
        },
        [events]
    );

    

    useEffect(()=>{
        getByGroup();
    },[])

    return (
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div class="list-group">
                            <li className={"list-group-item bg-dark"}>
                                <div className="text-center">
                                    <TaskForm masters={masters} onSuccess={getByGroup} />
                                </div>
                            </li>
                            <li className={"list-group-item bg-dark"}>
                                <Link className="btn btn-danger" to={"/task/archived"}>Archived List</Link>
                                <Link className="btn btn-outline-warning ms-3" to={"/task/dashboard"}> <List/> List View</Link>
                            </li>
                        </div>

                    </div>
                    <div className='col-md-9'>
                        <div className='row'>
                            <div className='col-md-12'>
                                {masters && taskList &&
                                    <DndProvider backend={HTML5Backend}>
                                    <div style={{ height: 700 }} className='bg-white p-2'> {/* The calendar container MUST have a height */}
                                        <DragAndDropCalendar
                                            localizer={localizer}
                                            events={events}
                                            startAccessor="start" // Tells the calendar which field in your mapped object is the start date
                                            endAccessor="end"     // Tells the calendar which field in your mapped object is the end date
                                            style={{ margin: '0px' }}
                                            defaultView='month' // Start on the month view
                                            // Optional: Set a default date to center the view
                                            defaultDate={new Date()} // October 1, 2025 (months are 0-indexed)
                                            //onSelectEvent={(event)=> setSelectedEvent(event.originalTask) }
                                            eventPropGetter={eventPropGetter}

                                            onEventDrop={moveEvent}      // Function called on event move
                                            onEventResize={resizeEvent}  // Function called on event resize

                                            components={{
                                            event: (props) => (
                                                    <TaskForm data={props.event.originalTask} onSuccess={getByGroup} masters={masters} getMasterLabel={getMasterLabel} clanderDisplay={true} />
                                                /*
                                                <CustomEvent
                                                    {...props}
                                                    callBack={getByGroup} masters={masters} getMasterLabel={getMasterLabel}
                                                    // Pass the callback prop name
                                                    //onCustomAction={handleEventAction} 
                                                />
                                                */
                                            ),
                                            }}
                                        />
                                    </div>
                                    </DndProvider>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
        
    );
};

export default TaskCalendarPage;